import { render, staticRenderFns } from "./indexhome.vue?vue&type=template&id=4213f12d&scoped=true&"
import script from "./indexhome.vue?vue&type=script&lang=js&"
export * from "./indexhome.vue?vue&type=script&lang=js&"
import style0 from "./indexhome.vue?vue&type=style&index=0&id=4213f12d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4213f12d",
  null
  
)

export default component.exports